export default {
    name: "main-nav",

    init() {
        const items = document.querySelectorAll('.js_toggle-main-menu');

        const navDialog = document.querySelector('#js_nav-dialog');

        for (let i = 0; i < items.length; i++) {
            items[i].addEventListener('click', (event) =>{
                if (navDialog.open === true) {
                    navDialog.close();
                    document.querySelector('.header').classList.remove('active-menu')
                } else {
                    navDialog.show();
                    document.querySelector('.header').classList.add('active-menu')
                }
            });
        }

        // force lose
        navDialog.addEventListener('click', (event) => {
            if (event.target.id === 'js_nav-dialog') {
                navDialog.close();
            }
        });
    },
};
